/** The delivery formats for a service */
import type { FilterIds } from '../../../types/FilterIds'
import type { FilterGroupObject } from './FilterDefinition'
import type { PickUnion } from '../../../types/PickUnion'

export type ServiceFilterDeliveryFormats = PickUnion<
  FilterIds,
  | 'type-of-service:in-person'
  | 'type-of-service:online'
  | 'type-of-service:telephone'
  | 'type-of-service:sms'
  | 'type-of-service:peer-support'
  | 'type-of-service:physical-activity'
  | 'type-of-service:telephone-or-text'
>

export const serviceFilterDeliveryFormats: ServiceFilterDeliveryFormats[] = [
  'type-of-service:in-person',
  'type-of-service:online',
  'type-of-service:telephone',
  'type-of-service:sms',
  'type-of-service:peer-support',
  'type-of-service:physical-activity',
  'type-of-service:telephone-or-text'
] as const

type DeliveryFormatsType = FilterGroupObject<ServiceFilterDeliveryFormats>

export const generateServiceFilterDeliveryFormatsObjects = (): DeliveryFormatsType => ({
  'type-of-service:in-person': {
    selected: false,
    label: 'In person',
    key: 'type-of-service:in-person',
    filterId: 'type-of-service:in-person',
    serviceFilterKey: 'offersInPersonSupport'
  },
  'type-of-service:online': {
    selected: false,
    label: 'Online service',
    key: 'type-of-service:online',
    filterId: 'type-of-service:online',
    serviceFilterKey: 'offersOnlineSupport'
  },
  'type-of-service:telephone-or-text': {
    selected: false,
    label: 'Telephone or text service',
    key: 'type-of-service:telephone-or-text',
    filterId: 'type-of-service:telephone-or-text',
    serviceFilterKey: (publicService) => {
      return publicService.offersTelephoneSupport || publicService.offersSmsSupport
    }
  },
  'type-of-service:physical-activity': {
    selected: false,
    label: 'Physical Activity and movement',
    key: 'type-of-service:physical-activity',
    filterId: 'type-of-service:physical-activity',
    serviceFilterKey: 'involvesPhysicalActivityAndMovement',
    toolTipContent:
      'Physical activity improves mood, reduces stress and anxiety, boosts self-esteem, and supports overall emotional well-being. These services or activities are designed and delivered to support mental health of people.'
  },
  'type-of-service:sms': {
    selected: false,
    label: 'SMS',
    key: 'type-of-service:sms',
    filterId: 'type-of-service:sms',
    frontEndHidden: true,
    serviceFilterKey: 'offersSmsSupport'
  },
  'type-of-service:peer-support': {
    selected: false,
    label: 'Peer support',
    key: 'type-of-service:peer-support',
    filterId: 'type-of-service:peer-support',
    frontEndHidden: true,
    serviceFilterKey: 'offersPeerGroupSupport'
  },
  'type-of-service:telephone': {
    selected: false,
    label: 'Telephone',
    key: 'type-of-service:telephone',
    filterId: 'type-of-service:telephone',
    frontEndHidden: true,
    serviceFilterKey: 'offersTelephoneSupport'
  }
})
